import { useMemo } from "react";

import { css, keyframes } from "@compiled/react";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { FireSvg } from "./assets/fire-svg";
import { RocketSvg } from "./assets/rocket-svg";

export const RocketAnimation = ({
    animationStep,
    progress
}: {
    animationStep: string;
    progress: number;
}) => {
    const animationStepInternal = useMemo(() => animationStep, [animationStep]);
    const shouldCenter = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <div
            css={[
                rocketContainer,
                shouldCenter && centeredRocketContainer,
                animationStepInternal === "rocket" && startAnimation
            ]}
        >
            <RocketSvg />
            <FireSvg progress={progress} />
        </div>
    );
};

const moveRocket = keyframes({
    from: {
        transform: "translate(0, 0)"
    },
    to: {
        transform: "translate(1000px, -1000px)"
    }
});

const rocketContainer = css({
    flex: 1,
    display: "block",
    margin: 30,
    width: 100,
    height: 100,
    position: "relative",
    animationName: `${moveRocket}`,
    animationDuration: "1.3s",
    animationTimingFunction: "ease-in-out",
    animationFillMode: "forwards",
    animationPlayState: "paused"
});

const centeredRocketContainer = css({
    paddingInlineStart: 10
});

const startAnimation = css({
    animationPlayState: "running"
});
